// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"139":"ce164784","637":"ab8f604a","898":"a5e3f2b1"}[chunkId] + ".chunk.css";
};